import { Injectable } from '@angular/core';
import {Restangular} from "ngx-restangular";
import {RestHttpService} from "@catcore/services/rest-http.service";

@Injectable()
export class ProjectPortService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('project-ports', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ports/services/project-port.service.ts